 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"1":"vue","2":"d3js","11":"d3_snowhist","12":"leaflet","14":"modal-feedback","15":"modal-feedback-detail-feedback","16":"modal-feedback-error","17":"modal-feedback-simple-select","18":"modal-feedback-success","22":"show-history-page","23":"sign-up","24":"sign-up/app-free-features-vue","25":"sign-up/promo-plan-panel-vue","26":"sign-up/snow-pro-benefits-vue","27":"sign-up/social-auth-buttons-vue","28":"sign-up/the-finish-vue","29":"sign-up/the-form-free-vue","30":"sign-up/the-form-premium-vue","31":"sign-up/the-payment-vue","32":"sign-up/the-plan-selection-vue","33":"sign-up/the-promo-login-vue","34":"sign-up/the-promo-signup-vue","35":"snow-history-snow-depth","36":"snow-report-page","38":"vendors~leaflet","39":"visual-report-detail-report","40":"visual-report-error","41":"visual-report-simple-select","42":"visual-report-success","43":"visualReport"}[chunkId]||chunkId) + "-" + {"1":"0ae0a1f9e256aa8136ed","2":"ed7a0e9d9a2ef06e48d2","11":"8fccbc2c5130b9424c6b","12":"b7d5f161f369ef59086c","14":"0de6ef4ad2450207bb76","15":"5c9f7677081dce419149","16":"7f1fc54cb3057ad9d829","17":"39ce3bd6f3e843d5f114","18":"41a96e2ed27a2af73d16","22":"05a1b9961be7c66ca764","23":"595492dfb673d6fb4b9e","24":"b8a43d64ba37871e0caf","25":"aab28a879a183b24ed5d","26":"5a31198680d30df16c28","27":"2b41939b9c5cf64488f7","28":"1f8e93730456c12d1e31","29":"9bdc611ed0373651c76c","30":"0d286dab026370d4ec30","31":"0c6a8e7db707007f8152","32":"e7d021781bcdcda0fcbf","33":"ddfa1cdef55fbf8884f3","34":"6ffff805c7c19246ffa5","35":"8566e31652e3b09de0dc","36":"18d8555f225c74293dc0","38":"05ba6532b4d71a5c5658","39":"916a9c87dbd7cb9476c7","40":"fac8ac4df4fdc62accdf","41":"932cdc9e3ba4e12c4b8c","42":"60f3ab23d07afb9af774","43":"b31e401bb2fbb11d308e"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"11":1,"12":1,"14":1,"15":1,"16":1,"17":1,"18":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"1":"vue","2":"d3js","11":"d3_snowhist","12":"leaflet","14":"modal-feedback","15":"modal-feedback-detail-feedback","16":"modal-feedback-error","17":"modal-feedback-simple-select","18":"modal-feedback-success","22":"show-history-page","23":"sign-up","24":"sign-up/app-free-features-vue","25":"sign-up/promo-plan-panel-vue","26":"sign-up/snow-pro-benefits-vue","27":"sign-up/social-auth-buttons-vue","28":"sign-up/the-finish-vue","29":"sign-up/the-form-free-vue","30":"sign-up/the-form-premium-vue","31":"sign-up/the-payment-vue","32":"sign-up/the-plan-selection-vue","33":"sign-up/the-promo-login-vue","34":"sign-up/the-promo-signup-vue","35":"snow-history-snow-depth","36":"snow-report-page","38":"vendors~leaflet","39":"visual-report-detail-report","40":"visual-report-error","41":"visual-report-simple-select","42":"visual-report-success","43":"visualReport"}[chunkId]||chunkId) + "-" + {"1":"e3b0c44298fc1c149afb","2":"e3b0c44298fc1c149afb","11":"8f3ba1f74ba9d65a8249","12":"0c67f6253124a456cb0a","14":"084508a9f826bc09c56e","15":"ba9ecbc3d83fea4592ef","16":"3452f499dfac52679c8b","17":"1fca309d715eea28656e","18":"1dfd6c590f960ff10a92","22":"ddbe3008445eb2f2feb4","23":"e08703cbea36e93471a6","24":"f21b398619ef78568f53","25":"2324e7384b6971235954","26":"75adc06d02de6c4048ad","27":"bd1caa84b7fe760d6c6d","28":"9c206a8a05288b1c7864","29":"c338e69072a02c0e8933","30":"0000bce347591a950209","31":"0652dac187276aa29746","32":"0382e67216d539779cca","33":"a8b532175211c3a8e3af","34":"264f90355fd606b27cc7","35":"ce6b545184ba8ec5ee04","36":"ce6b545184ba8ec5ee04","38":"2e6ddc2d7e6698f3c70d","39":"44757b1d68294caadbb1","40":"b702a7a17b84696b21ed","41":"aa2118b9635ef3a51881","42":"e6d09e0b932c4e93f252","43":"50d22f40d0fb14dee8ca"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
